module.exports = __webpack_public_path__ + "img/cover.838df021.png";